(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!window.__genderSelectorInit) {
    window.__genderSelectorInit = true;

    const validate = (form) => {
      const fieldset = form.querySelector('[data-gender-selector]');
      if (!fieldset) return true;
      const ok = !!fieldset.querySelector('input[type="radio"]:checked');
      fieldset.classList.toggle('product-gender-selector--invalid', !ok);
      fieldset.querySelector('.product-gender-selector__error').hidden = ok;
      if (!ok) fieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return ok;
    };

    // Add to cart + Buy it now buttons
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.product-form__buttons');
      if (!btn) return;
      const form = btn.closest('form');
      if (form && !validate(form)) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }, true);

    // Enter key submit
    document.addEventListener('submit', (e) => {
      if (e.target.matches('form') && !validate(e.target)) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }, true);

    // Hide error once selected
    document.addEventListener('change', (e) => {
      if (!e.target.matches('.product-gender-selector__input')) return;
      const fieldset = e.target.closest('[data-gender-selector]');
      fieldset.classList.remove('product-gender-selector--invalid');
      fieldset.querySelector('.product-gender-selector__error').hidden = true;
    });
  }
  } catch(e) { console.error(e); }
})();

})();
